module.exports = __webpack_public_path__ + "img/achievement-icon.1779ad4.svg";